export const inactiveFusesContants = {
  INACTIVE_FUSES_LOADING: "INACTIVE_FUSES_LOADING",
  INACTIVE_FUSES_SUCCESS: "INACTIVE_FUSES_SUCCESS",
  INACTIVE_FUSES_FAILURE: "INACTIVE_FUSES_FAILURE",
};
